import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const CTASection = () => {
  const { t } = useLanguage();

  return (
    <section className="relative py-32 bg-[#003366] overflow-hidden">
      <div className="relative max-w-6xl mx-auto px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-3 mb-8">
          <div className="h-px w-16 bg-[#D4AF37]" />
          <span className="text-white/60 text-sm font-medium uppercase tracking-[0.3em]">
            {t('ready', { de: 'Bereit zu starten?', en: 'Ready to Start?' })}
          </span>
          <div className="h-px w-16 bg-[#D4AF37]" />
        </div>

        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-[1.1] tracking-tight">
          {t('ctaLine1', { de: 'Lassen Sie uns Ihr', en: "Let's Strengthen Your" })}
        </h2>
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-10 leading-[1.1] tracking-tight">
          <span className="text-[#D4AF37]">
            {t('ctaHighlight', { de: 'Hospitality-Geschäft', en: 'Hospitality Business' })}
          </span>
          <span className="text-white">
            {t('ctaLine2', { de: ' gemeinsam stärken', en: ' Together' })}
          </span>
        </h2>

        <p className="text-lg md:text-xl text-white/70 mb-12 max-w-3xl mx-auto leading-relaxed">
          {t('ctaDesc', { 
            de: 'Kontaktieren Sie uns noch heute und erfahren Sie, wie wir Ihre Personalbedürfnisse optimal erfüllen können.',
            en: 'Contact us today and discover how we can optimally meet your staffing needs.'
          })}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/contact" className="group relative inline-flex items-center justify-center gap-3 px-10 py-5 bg-[#D4AF37] text-[#003366] font-bold text-lg rounded-md border border-[#B8960C] overflow-hidden transition-all duration-300 hover:shadow-2xl hover:shadow-[#D4AF37]/30 hover:scale-105 hover:bg-[#C9A227]">
            <span>{t('contactNow', { de: 'Jetzt Kontakt aufnehmen', en: 'Contact Us Now' })}</span>
            <ArrowRight size={22} className="group-hover:translate-x-1 transition-transform" />
          </Link>
          <Link to="/about" className="inline-flex items-center justify-center gap-3 px-10 py-5 border-2 border-white/20 text-white font-semibold text-lg rounded-md hover:bg-white/5 hover:border-[#D4AF37]/50 hover:text-[#D4AF37] transition-all duration-300">
            {t('moreAbout', { de: 'Mehr über uns', en: 'More About Us' })}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
